import React from 'react';
import { ModalType } from '@wix/da-shared-react/pkg/Modals/redux/types';
import { PostPopupMode } from './modals/WriterPopup/types';
import LoadableDeviationSubmitPopup from './modals/DeviationSubmitPopup';
import LoadablePostPopup from './modals/PostPopup';
import LoadableWriterPopup from './modals/WriterPopup/LoadableWriterPopup';
import CustomExclusivePopup from './modals/CustomExclusivePopup';

export const submitModalRenderer = (
  modalType: string,
  requestClose: () => void,
  params?: any
) => {
  switch (modalType) {
    case ModalType.DEVIATION_SUBMIT:
      return (
        <LoadableDeviationSubmitPopup requestClose={requestClose} {...params} />
      );

    case ModalType.STATUS_UPDATE:
      return (
        <LoadablePostPopup
          onClose={requestClose}
          {...params}
          mode={PostPopupMode.STATUS}
        />
      );

    case ModalType.JOURNAL:
      return (
        <LoadablePostPopup
          onClose={requestClose}
          {...params}
          mode={PostPopupMode.JOURNAL}
        />
      );

    case ModalType.LITERATURE:
      return (
        <LoadableWriterPopup
          onClose={requestClose}
          {...params}
          type="LITERATURE"
        />
      );

    case ModalType.CUSTOM_EXCLUSIVE:
      return <CustomExclusivePopup onRequestClose={requestClose} />;

    default:
      return null;
  }
};
